<template functional>
  <svg :class="[data.class, data.staticClass, 'stella-icon']" :style="data.staticStyle" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path v-if="props.filled" d="M20 7H17.2C17.7 6.1 18 5.1 18 4C18 2.3 16.7 1 15 1C13.5 1 12.3 2 12 3.4C11.7 2 10.5 1 9 1C7.3 1 6 2.3 6 4C6 5.1 6.3 6.1 6.8 7H4C2.9 7 2 7.9 2 9V11C2 11.6 2.4 12 3 12H4V21C4 22.1 4.9 23 6 23H18C19.1 23 20 22.1 20 21V12H21C21.6 12 22 11.6 22 11V9C22 7.9 21.1 7 20 7ZM15 3C15.6 3 16 3.4 16 4C16 4.6 15.6 5 15 5C14.1 5 13.3 4.3 13.1 3.4C13.5 3.2 14.2 3 15 3ZM8 4C8 3.4 8.4 3 9 3C9.8 3 10.5 3.2 10.9 3.4C10.7 4.3 9.9 5 9 5C8.4 5 8 4.6 8 4ZM11 21H6V12H11V21ZM11 10H4V9H11V10ZM18 21H13V12H18V21ZM20 10H13V9H20V10Z" fill="currentColor"/>
    <path v-else d="M20 7H17.2C17.7 6.1 18 5.1 18 4C18 2.3 16.7 1 15 1C13.5 1 12.3 2 12 3.4C11.7 2 10.5 1 9 1C7.3 1 6 2.3 6 4C6 5.1 6.3 6.1 6.8 7H4C2.9 7 2 7.9 2 9V11C2 11.6 2.4 12 3 12H4V21C4 22.1 4.9 23 6 23H18C19.1 23 20 22.1 20 21V12H21C21.6 12 22 11.6 22 11V9C22 7.9 21.1 7 20 7ZM15 3C15.6 3 16 3.4 16 4C16 4.6 15.6 5 15 5C14.1 5 13.3 4.3 13.1 3.4C13.5 3.2 14.2 3 15 3ZM8 4C8 3.4 8.4 3 9 3C9.8 3 10.5 3.2 10.9 3.4C10.7 4.3 9.9 5 9 5C8.4 5 8 4.6 8 4ZM11 21H6V12H11V21ZM4 10V9H11V10H4ZM13 12H18V21H13V12ZM13 10V9H20V10H13Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconRequests",
  props: {
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
